import { Complaint } from '../Complaint'
import { formSchema } from './schema'
import { otherComplaint } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class OtherComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'other_complaint'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.othercomplaint.confirmation
  }

  /*
   * Combine the OTHER unique data with the common complaint data.
   */
  formatComplaintForRequest(formData) {
    // Process the data unique to this complaint.
    const { business_unit, hhs_program_detail, office_of_secretary } = formData

    const detail = {
      business_unit,
      hhs_program_detail,
      office_of_secretary
    }

    // Return the combined unique data and common data.
    return this.formatCommonComplaintFormData(formData, detail)
  }
}

export default withRecaptcha(
  withBackButtonProtection(withDocTitle(OtherComplaint, otherComplaint))
)
